var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown",class:{ opened: _vm.show }},[_c('div',{staticClass:"slot-toggle",on:{"click":function($event){$event.stopPropagation();_vm.toggle($event)}}},[_vm._t("toggle")],2),_vm._v(" "),_c('div',{staticClass:"slot-list",on:{"click":function($event){$event.stopPropagation();}}},[(_vm.show)?_vm._t("list"):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc894970","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ext/dropdown/dropdown.vue
// module id = 666
// module chunks = 1